export default "__VITE_ASSET__hbLdzHSe__"